module.exports = __webpack_public_path__ + "img/qr.cc69554b.png";